import jQuery from 'jquery';

export function setMobileMenuActions() {
  jQuery('#weathermenu-icon').click(function() {
    jQuery('#weather-mobilemenu').toggle();
    jQuery('#weathermenu-close').toggle();
    jQuery('#weathermenu-icon').toggle();
  });
  
  jQuery('#weathermenu-close').click(function() {
    jQuery('#weather-mobilemenu').toggle();
    jQuery('#weathermenu-close').toggle();
    jQuery('#weathermenu-icon').toggle();
  });
}